// extracted by mini-css-extract-plugin
export default {"btn":"UploadImage_btn__FhPKj","uploadImage":"UploadImage_uploadImage__I6xAm","preview":"UploadImage_preview__ASguS"};